import { createAction, props } from '@ngrx/store';
import { InsuranceDoc } from '../_models/insuranceDoc';

// Action types
export const loadInsuranceDocs = createAction('[InsuranceDoc] Load InsuranceDocs');
export const loadInsuranceDocsSuccess = createAction(
  '[InsuranceDoc] Load InsuranceDocs Success',
  props<{ insuranceDocs: InsuranceDoc[] }>()
);
export const loadInsuranceDocsFailure = createAction(
  '[InsuranceDoc] Load InsuranceDocs Failure',
  props<{ error: any }>()
);

export const addInsuranceDoc = createAction(
  '[InsuranceDoc] Add InsuranceDoc',
  props<{ insuranceDoc: InsuranceDoc }>()
);
export const addInsuranceDocSuccess = createAction(
  '[InsuranceDoc] Add InsuranceDoc Success',
  props<{ insuranceDoc: InsuranceDoc }>()
);
export const addInsuranceDocFailure = createAction(
  '[InsuranceDoc] Add InsuranceDoc Failure',
  props<{ error: any }>()
);

export const updateInsuranceDoc = createAction(
  '[InsuranceDoc] Update InsuranceDoc',
  props<{ insuranceDoc: InsuranceDoc }>()
);
export const updateInsuranceDocSuccess = createAction(
  '[InsuranceDoc] Update InsuranceDoc Success',
  props<{ insuranceDoc: InsuranceDoc }>()
);
export const updateInsuranceDocFailure = createAction(
  '[InsuranceDoc] Update InsuranceDoc Failure',
  props<{ error: any }>()
);

export const deleteInsuranceDoc = createAction(
  '[InsuranceDoc] Delete InsuranceDoc',
  props<{ id: number }>()
);
export const deleteInsuranceDocSuccess = createAction(
  '[InsuranceDoc] Delete InsuranceDoc Success',
  props<{ id: number }>()
);
export const deleteInsuranceDocFailure = createAction(
  '[InsuranceDoc] Delete InsuranceDoc Failure',
  props<{ error: any }>()
);
